export type WorkflowExecutionStatus = 'InProgress' | 'Success' | 'Failure' | 'Skipped';

export type WorkflowTaskStatus =
  | 'Queued'
  | 'Dispatching'
  | 'Dispatched'
  | 'InProgress'
  | 'Success'
  | 'Failure'
  | 'Skipped';

export type ExecutionSummary = {
  executionId: string;
  brandId: string;
  workflowType: string;
  status: WorkflowExecutionStatus;
  triggerType: string;
  createdAt: string;
  startedAt: string | null;
  /* When the first task actually began running. startedAt is stamped when that task is only
     queued, so it carries the ECS provisioning wait; this doesn't. */
  firstTaskStartedAt: string | null;
  endedAt: string | null;
  errorMessage: string | null;
};

export type LatestExecution = ExecutionSummary & {
  isFirstRun: boolean;
};

export type BrandScheduler = {
  workflowType: string;
  cronExpression: string;
  isActive: boolean;
};

export type ExecutionTask = {
  taskId: number;
  taskKey: string;
  status: WorkflowTaskStatus;
  startedAt: string | null;
  endedAt: string | null;
  payloadUri: string | null;
  resultUri: string | null;
  cloudWatchUrl: string | null;
};

export type ExecutionDetails = ExecutionSummary & {
  failedTaskKey: string | null;
  tasks: ExecutionTask[];
};

/* One row of the shared execution list; only Latest-tab rows carry isFirstRun */
export type WorkflowExecutionRow = ExecutionSummary & {
  isFirstRun?: boolean;
  scheduler: BrandScheduler | null;
};

/* One Status-tab row: the latest execution of a workflow type merged with its scheduler */
export type BrandWorkflowRow = LatestExecution & {
  scheduler: BrandScheduler | null;
};

export const BRAND_WORKFLOW_TABS = {
  Latest: 'latest',
  ManualTriggers: 'manual-triggers'
} as const;

export type BrandWorkflowTab = (typeof BRAND_WORKFLOW_TABS)[keyof typeof BRAND_WORKFLOW_TABS];

export type KickOffError = {
  workflowType: string;
  message: string;
};
